import { ArticleView, type CollectionDto, MAX_ARTICLES_PER_COLLECTION } from "@serophin/nottldr-shared";
import { useArticleList } from "@serophin/nottldr-shared/hooks";
import { useMemo } from "preact/hooks";
import { ArticleList } from "../feed/ArticleList";
import { ARTICLE_LIMIT_MESSAGE } from "./collectionText";
import { PillPicker } from "./PillPicker";

export type ViewCollectionsProps = {
  selectedId: string;
  collections: CollectionDto[];
  onSelect: (collection: CollectionDto) => void;
};

const EMPTY =
  "No articles have been added to this collection yet. Explore our articles and authors to discover interesting content, and bookmark them to your own collections!";

const nameById = (collections: CollectionDto[]): Record<string, string> =>
  Object.fromEntries(collections.map((collection) => [collection.id, collection.name]));

export const ViewCollections = ({ selectedId, collections, onSelect }: ViewCollectionsProps) => {
  const list = useArticleList(ArticleView.COLLECTION, { collectionId: selectedId }, selectedId);
  const names = useMemo(() => nameById(collections), [collections]);
  const atLimit = list.metas.length >= MAX_ARTICLES_PER_COLLECTION;

  const select = (id: string) => {
    const collection = collections.find((item) => item.id === id);
    if (collection) {
      onSelect(collection);
    }
  };

  return (
    <>
      <div class="mb-3 bg-white dark:bg-neutral-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden p-2">
        <PillPicker id="collections" value={selectedId} onChange={select} values={names} />
      </div>
      <ArticleList list={list} showReadFilter emptyMessage={EMPTY} endMessage={atLimit ? ARTICLE_LIMIT_MESSAGE : undefined} />
    </>
  );
};
